import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrltlCommodityLookup extends Layout {
    sourceLtlCommodity: DataSource;
    tableCommodity: Table;
}
